module.exports = __webpack_public_path__ + "img/sollicitation.55953750.png";